export const BAR_WIDTH = 2;
export const BAR_GAP = 2;
export const MIN_BAR_HEIGHT = 3;

export const WAVE_COLOR = "#9a6aff";
export const PLAYED_COLOR = "#ffffff";
export const FALLBACK_COLOR = "#5a6478";
export const FALLBACK_PLAYED_COLOR = "#8b95a8";

export const barsCountForWidth = (width) =>
  Math.max(16, Math.floor(width / (BAR_WIDTH + BAR_GAP)));
